import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchDesignationsList } from "./designationsThunks";
import { Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DesignationList from "./components/DesignationList";

const { Title } = Typography;

const Designations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { designations } = useSelector((state) => state.designations);

  useEffect(() => {
    dispatch(fetchDesignationsList());
  }, [dispatch]);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
          onClick={() => navigate(-1)}
          data-testid="designations-back-button"
        />
        <Title level={2} style={{ margin: 0 }}>Designation</Title>
      </div>
      <DesignationList designationsList={designations} />
    </>
  );
};

export default Designations;
